<template>
  <div>
    <section class="theme-list" v-if="bill">
      <div style="padding: 0.2rem 0.24rem 0">
        <div class="time_box" @click="show = true">
          <span>{{ month }}</span>
          <img src="../assets/rili.png" class="rili_img" />
        </div>
      </div>
      <div id="powerFeeBill" style="height:6.7rem">
        <div
          id="powerBill"
          style="
          padding: 0 0.24rem 0.24rem;
          z-index: 5;
          text-align: -webkit-center;
        "
        >
          <img style="width: 100%" src="../assets/bill-bgHead1.png" class="img-responsive" />
          <div id="billDetail">
            <div class="bill-name">
              <p style="letter-spacing: 0.02rem">电量电费账单</p>
            </div>
            <div class="row" style="font-size:0.2rem">
              <div class="col">计费年月：{{ bill.date }}</div>
              <div class="col">客户编号：{{ bill.consNo }}</div>
              <div class="col">客户名称：{{ bill.consName }}</div>
              <div class="col">用电地址：{{ bill.elecAddr }}</div>
            </div>

            <div
              style="
              color: #606060;
              line-height: 0.24rem;
              margin:0rem 0.35rem 0;
              font-size: 0.18rem;
            "
            >
              <div class="project_table">
                <div class="table_head">
                  <div style="width:33%;text-align:left">计费方案</div>
                  <div style="width:33%;text-align:center">电量</div>
                  <div style="width:33%;text-align:right">金额（元）</div>
                </div>
                <div class="table_body">
                  <div style="width:33%;text-align:left">{{bill.schemeName}}</div>
                  <div style="width:33%;text-align:center">{{bill.number}}kWh</div>
                  <div style="width:33%;text-align:right">{{bill.amount}}</div>
                </div>
                <div class="table_foot">
                  <div>合计</div>
                  <div>{{bill.amount}}</div>
                </div>
              </div>
              <span style="color: #ff0f38">*</span>温馨提示：本账单仅作为参考，以实际结算收据为准。
            </div>
            <div style="position: absolute; right: 0.38rem; top:0.5rem">
              <img alt src="../assets/hasSettled.png" style="width: 1.15rem" />
            </div>
          </div>
          <img
            style="width: 100%; position: relative; top: -74px"
            src="../assets/bill-bgBottom1.png"
            class="img-responsive"
          />
        </div>
      </div>
      <div class="line"></div>
      <div class="meterbox">
        <div class="colum-title">
          <span class="title" style="margin-left:0.1rem">抄表明细</span>
        </div>
        <div class="meter_head">
          <div style="width:29%;text-align:center; padding: 0 1%;">电能表编号</div>
          <div style="width:19%;text-align:center;padding: 0 1%;">示数<br>类型</div>
          <div style="width:14%;text-align:center;padding: 0 1%;">综合<br>倍率</div>
          <div style="width:19%;text-align:center;padding: 0 1%;">上次<br>示数</div>
          <div style="width:19%;text-align:center;padding: 0 1%;">本次<br>示数</div>
        </div>
        <div class="meter_body">
          <div style="width:29%;text-align:center;padding: 0 1%;">{{bill.meterNbbh}}</div>
          <div style="width:19%;text-align:center;padding: 0 1%;">有功(总)</div>
          <div style="width:14%;text-align:center;padding: 0 1%;">{{bill.beil}}</div>
          <div style="width:19%;text-align:center;padding: 0 1%;">{{bill.lastReadValue}}</div>
          <div style="width:19%;text-align:center;padding: 0 1%;">{{bill.readValue}}</div>
        </div>
      </div>
      <van-popup v-model="show" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择年月"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="confirm"
          @cancel="cancel"
        />
      </van-popup>
    </section>
    <div v-else>
      <img src="../assets/nodata.png" class="nodata_img" />
      <div class="nodata_notice">暂无数据!</div>
    </div>
  </div>
</template>

<script>
import { queryPowerUseBill } from "@/api/user.js";
import Vue from "vue";
import { Notify, DatetimePicker, Popup } from "vant";
Vue.use(Notify);
Vue.use(DatetimePicker);
Vue.use(Popup);
export default {
  data() {
    return {
      show: false,
      currentMonth: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      consId: "",
      theme: [],
      activeId: 0,
      bill: {},
      month: ""
    };
  },
  created() {
    this.consId = this.$route.query.consId ? this.$route.query.consId : "";

    if (this.$route.query.month) {
      this.month = this.$route.query.month;
      this.currentDate = new Date(
        this.month.substr(0, 4),
        this.month.substr(5),0
      );
    } else {
      this.currentYear = new Date().getFullYear();
      this.currentMonth = new Date().getMonth();
      this.maxDate = new Date(this.currentYear, this.currentMonth, 0);
      this.month = this.getLastMonth();
    }

    this.queryPowerUseBill();
  },
  methods: {
    //获取上月
    getLastMonth() {
      //获取当前上个月份yyyy-MM格式日期，返回值为字符串格式
      var date = new Date(new Date().setDate(1) - 86400000);
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : "" + month;
      return date.getFullYear() + "-" + month;
    },

    initTime(t) {
      let d = new Date(t).getTime(new Date(t));
      let time = new Date(d + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ")
        .replace(/\./g, "-");
      return time;
    },

    confirm(data) {
      this.month = this.initTime(data).substring(0, 7);
      this.queryPowerUseBill();
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    queryPowerUseBill() {
      if (this.consId) {
        queryPowerUseBill({ consId: this.consId, month: this.month }).then(
          res => {
            if (res.data.status == 200) {
              this.bill = res.data.object;
            } else {
              this.bill = null;
            }
          }
        );
      }
    }
  }
};
</script>


<style  scoped>
.nodata_img {
  width: 3.2rem;
  height: 3.2rem;
}
.nodata_notice {
  font-size: 0.28rem;
}
.meter_body>div {
  table-layout: fixed;
	word-wrap: break-word;
	word-break: normal;
	overflow: hidden;
}
.meter_body {
  display: flex;
  height: 1rem;
  padding: 0 0.2rem;
  font-size: 0.24rem;
  justify-content: space-between;
  align-items: center;
}
.meter_head {
  padding: 0 0.2rem;
  display: flex;
  height: 0.8rem;
  font-size: 0.24rem;
  background: #f7f8fa;
  justify-content: space-between;
  align-items: center;
}
.colum-title::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  margin-top: -1px;
  width: 0.04rem;
  height: 0.26rem;
  background-color: #50c7a1;
}
.colum-title {
  text-align: left;
  font-size: 0.26rem;
  margin-left: 0.13rem;
  line-height: 0.26rem;
}
.colum-title {
  color: #333;
  height: 0.26rem;
  line-height: 0.26rem;
  margin: 0.26rem 0;
  padding: 0 0.28rem;
  font-size: 0.28rem;
}
.line {
  width: 100%;
  height: 5px;
  background: #f7f8fa;
}
.content_box {
  width: 92%;
  height: 500px;
  margin: 0 auto;
  position: relative;
}

.time_box {
  padding: 0.05rem 0.14rem;
  border: 1px solid #1bbc9b;
  border-radius: 0.1rem;
  display: flex;
  font-size: 0.22rem;
  width: 1.4rem;
  height: 0.35rem;
  align-items: center;
  justify-content: space-around;
}
.rili_img {
  width: 0.28rem;
  height: 0.28rem;
  margin-left: 0.1rem;
}
.theme-list {
  margin-top: 12px;
}
.fixed-nav {
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}
.fixed-nav-content {
  display: flex;
}
.tab-title {
  padding: 0 13px;
  margin-right: 12px;
  color: #141414;
  border-radius: 13px;
  font-size: 12px;
  flex-shrink: 0;
  height: 0.52rem;
  line-height: 0.52rem;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 0.01rem;
  opacity: 0;
  display: none;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  background-color: #fff;
  opacity: 0;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  width: 0.01rem;
  border-radius: 0.01rem;
  opacity: 0;
}

.bill-name {
  width: 100%;
  color: #333;
  font-size: 0.26rem;
  text-align: center;
  margin-bottom: 0.3rem;
}

#billDetail {
  background-size: 5.9rem;
  z-index: 5;
  text-align: left;
  width: 100%;
  position: relative;
  top: -0.64rem;
  border-left: 2px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  box-sizing: border-box;
}

#billDetail .row {
  padding: 0 0.5rem;
  font-size: 0.24rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px dashed #dbdbdb;
}

.table_head {
  display: flex;
  height: 0.8rem;
  line-height: 0.8rem;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
}
.table_body {
  display: flex;
  height: 0.8rem;
  line-height: 0.8rem;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
}
.table_foot {
  display: flex;
  height: 0.8rem;
  line-height: 0.8rem;
  align-items: center;
  justify-content: space-between;
}

.col {
  line-height: normal;
  margin-bottom: 0.2rem;
}
</style>